// app-currency-input-basic.component.ts
import { Component, ViewChild, forwardRef, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'app-currency-input-basic',
  templateUrl: './currency-input-basic.component.html',
  styleUrls: ['./currency-input-basic.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyInputBasicComponent),
      multi: true
    }
  ]
})
export class CurrencyInputBasicComponent implements ControlValueAccessor {
  @ViewChild('amountInput', { static: false }) amountInput: IonInput;
  value: number = 0;

  

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.value = value || '';
    if (this.amountInput) {
      this.amountInput.value = this.value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (this.amountInput) {
      this.amountInput.disabled = isDisabled;
    }
  }

  // Custom methods
  onInput(event: any): void {
    const value = event.target.value;
    if (this.isValidCurrency(value) && parseFloat(value) > 0) {
      this.value = value;
      this.onChange(this.value);
    } else {
      // Si el valor no es válido o es menor o igual a 0, lo reseteamos
      this.value = 0;
      this.onChange(this.value);
    }
  }

  numericOnly(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.charCode);
    const currentValue = (event.target as HTMLInputElement).value;

    // Permitir solo números, un punto y hasta dos decimales
    if (!/^\d*\.?\d{0,2}$/.test(currentValue + inputChar)) {
      event.preventDefault();
    }
  }

  private isValidCurrency(value: string): boolean {
    // Validar que el valor sea un número con hasta dos decimales
    return /^\d*\.?\d{0,2}$/.test(value);
  }

  // Placeholder for the callbacks which are later provided by the Control Value Accessor
  private onChange: any = () => {};
  private onTouched: any = () => {};
}